import { render, staticRenderFns } from "./PollResultsWithTextField.vue?vue&type=template&id=99b8ab70&"
import script from "./PollResultsWithTextField.vue?vue&type=script&lang=ts&"
export * from "./PollResultsWithTextField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports